module.exports = __webpack_public_path__ + "img/7.0a8552c.webp";